module.exports = __webpack_public_path__ + "static/media/beyond-travel-logo.c5da0591.png";